<template>
  <footer>
    <div class="block cmi-footer">
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <img
              class="img-responsive cmi-footer-logo"
              src="/dist/assets/logos/rupc_main_logo_001.png"
              alt="Rightway CHURCH LOGO AND TEXT"
            />
          </div>
          <div id="contact" class="col-md-4">
            <h3 class="cmi-contact-h">CONTACTS</h3>
            <div class="widget">
              <div class="about">
                <div class="contact cmi-footer-text">
                  <ul>
                    <li>
                      <span class="cmi-contact-span"
                        ><i class="fa fa-phone"></i>Mobile : </span
                      >(514) 701-7377
                    </li>
                    <li>
                      <span class="cmi-contact-span"
                        ><i class="fa fa-envelope"></i>E-mail : </span
                      >office@rightwayupc.ca
                    </li>
                    <li>
                      <span class="cmi-contact-span"
                        ><i class="fa fa-home"></i>Address : </span
                      ><br />
                      Lachine Rightway<br />
                      United Pentecostal Church<br />
                      Église Pentecôtiste Du Vrai Chemin<br />
                      929 14e Avenue<br />
                      Lachine<br />
                      QC H8S 4E5<br />
                      Canada
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="cmi-quick-links">
              <account></account>
            </div>
            <div class="widget">
              <div class="about">
                <ul class="social-media">
                  <li>
                    <a
                      title="RUPC CHURCH Facebook"
                      href="https://www.facebook.com/rightwaypentecostal"
                      target="_blank"
                      ><i class="fa fa-facebook"></i
                    ></a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" title=""
                      ><i class="fa fa-twitter"></i
                    ></a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" title=""
                      ><i class="fa fa-linkedin"></i
                    ></a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" title=""
                      ><i class="fa fa-google-plus"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import Account from "./UserAccount";
export default {
  components: {
    Account
  },
  data() {
    return {};
  }
};
</script>
